import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface MarketState {
    valentineData: {
        serverId: string,
        word: string,
    } | null;
    valentineKey: string | null;
}

const m: Module<MarketState, RootState> = {
    namespaced: true,
    state: () => ({
        valentineData: null,
        valentineKey: null,
    }),
    mutations: {
        setValentineData(state, data) {
            state.valentineData = data;
        },
        /**
         * 图片key
         */
        setValentineKey(state, key) {
            state.valentineKey = key;
        },
    },
    actions: {
        async recordValentine({ state, commit }, key) {
            // 已经提交过了，不再提交
            if (state.valentineKey === key) {
                return;
            }
            const response = await Vue.axios.post('/api/v1/temp_activity/valentine', {
                image: key,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setValentineKey', key);
            }
            return rdata;
        },
    },
};

export default m;
